// extracted by mini-css-extract-plugin
module.exports = {"container":"AddNotification_container__3m8Le","textInput":"AddNotification_textInput__3_iST"};